import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const CallsFilter = ({fromDate, toDate, setFromDate, setToDate, lat, lng, setLat, setLng, sourceIdentifier2, setSourceIdentifier2, applyFilters, clearFilters}) =>
    <form className="calls-filter" onSubmit={event => {event.preventDefault(); applyFilters();}}>
        <div className="filter-row">
            <label>From<DatePicker selected={fromDate} onChange={setFromDate}
                maxDate={toDate || new Date()} placeholderText="From date"/></label>
            <label>To<DatePicker selected={toDate} onChange={setToDate}
                minDate={fromDate} maxDate={new Date()} placeholderText="To date"/></label>
        </div>
        <div className="filter-row">
            <label>Lat<input type="number" step="any" min="-90" max="90" value={lat ?? ""}
                onChange={event => setLat(event.target.value)} placeholder="Latitude"/></label>
            <label>Lng<input type="number" step="any" min="-180" max="180" value={lng ?? ""}
                onChange={event => setLng(event.target.value)} placeholder="Longitude"/></label>
        </div>
        <div className="filter-row"><label>Group<input type="text" value={sourceIdentifier2 ?? ''}
            onChange={event => setSourceIdentifier2(event.target.value)} placeholder="Source identifier 2"/></label></div>
        <div className="filter-row">
            <button className="filter-apply" type="submit">Apply filter</button>
            <button className="filter-apply filter-clear" type="button" onClick={clearFilters}>Clear</button>
        </div>
    </form>;
export default CallsFilter;
